import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getAllEnabledCountries, getQuoteTypeText } from '../../../../../utils/utility';

const createdStatusOptions = [
    { id: "ACCEPTED", label: "Accepted" },
    { id: "LOST", label: "Lost" },
    { id: "ON_HOLD", label: "On Hold" },
    { id: "POSTPONED_TO_NEXT_QUARTER", label: "Postponed To Next Quarter" }
];

const partiallyCreatedStatusOptions = [
    { id: "POSTPONED_TO_NEXT_QUARTER", label: "Postponed To Next Quarter" }
];

const postponedToNextQuarterStatusOptions = [
    { id: "ACCEPTED", label: "Accepted" },
    { id: "LOST", label: "Lost" },
    { id: "ON_HOLD", label: "On Hold" },
];

const vendorPricesPendingStatusOptions = [
    { id: "ON_HOLD", label: "On Hold" }
];
const onHoldStatusOptions = [
    { id: "VENDOR_PRICES_PENDING", label: "Vendor Prices Pending" }
];
const onHoldStatusCreationOptions = [
    { id: 'CREATED', label: "Created" },
    { id: "ACCEPTED", label: "Accepted" },
    { id: "LOST", label: "Lost" },
];

const revitalizeHPPricesPendingOptions = [
    { id: "REQUESTED", label: "Requested" }
];

const QUOTE_EDIT_DISABLED = ['ACCEPTED', 'LOST'];
const EDITABLE_COLUMNS = ["customerName", "orgId", "contactPersonEmail", "ctResponsible", "salesPersonEmail", "status", "revitalizeHPPrices", "requestorType", "requestType", "leadOrigin", "leadSource", "leadCountry", "quoteCreationDate", "npsSurveySent", "dateSurveySent", "quotationSubmissionDate", "acceptanceRejectionDate", "winningDeliveryPartner", "revitalizeCountries", "numberOfRevitalizeAssets"];

export default function EditQuoteColumnSpecification(config) {
    const { quote, directCustomerQuote } = useSelector(state => state);
    const { quoteListCopy = [] } = quote;
    const { requestTypeOptions = [], leadOriginOptions = [], leadSourceOptions = [] } = directCustomerQuote;
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    function isNotEditable(status, columnId) {
        if (EDITABLE_COLUMNS.includes(columnId)) {
            return false;
        }
        else if (columnId === "acceptanceRejectionDate" && QUOTE_EDIT_DISABLED.includes(status)) {
            return false;
        }
        else if (QUOTE_EDIT_DISABLED.includes(status) || status === "VENDOR_PRICES_PROVIDED" || status === "VENDOR_PRICES_PENDING" || status === "CREATED" || status === "ON_HOLD") {
            return true;
        }
    }

    config.data.forEach((quote, index) => {
        let row = [];
        const rowId = config.tableType;
        let clickHandler = null;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            const highlightColumn = column.data.highlightBodyText;

            let isNotEditableQuote = isNotEditable(quote.status, columnId);

            let columnValue = null;
            let isDisabled = false;
            let columnValueData = null;

            if (columnDataType === "string") {
                if (columnId === "quoteId") {
                    columnValue = quote.quoteId;
                    columnValueData = quote.quoteId
                }
                else if (columnId === "geographicalScope") {
                    columnValue = quote.geographicalScope;
                    columnValueData = quote.geographicalScope;
                }
                else if (columnId === "region") {
                    columnValue = quote.region;
                    columnValueData = quote.region;
                }
                else if (columnId === "quoteType") {
                    columnValue = getQuoteTypeText(quote.quoteType);
                    columnValueData = columnValue;
                }
            }
            if (columnDataType === "input") {
                clickHandler = (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, index) : null
                if (columnId === "customerName") {
                    columnValue = quote.customerName || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = !quote.companyOrgIdEditable;
                }
                else if (columnId === "orgId") {
                    columnValue = quote.orgId || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = !quote.companyOrgIdEditable;
                }
                else if (columnId === "contactPersonEmail") {
                    columnValue = quote.contactPersonEmail || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "requestDate") {
                    columnValue = getDateWithSpecificFormat(quote.requestDate) || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "quoteCreationDate") {
                    if (quote.status === "CREATED") {
                        isNotEditableQuote = false;
                    } else if (quote.status === "DRAFT") {
                        isNotEditableQuote = true;
                    }
                    columnValue = quote.quoteCreationDate ? getDateWithSpecificFormat(quote.quoteCreationDate) : "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "dateSurveySent") {
                    columnValue = quote.dateSurveySent ? getDateWithSpecificFormat(quote.dateSurveySent) : "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = quote.npsSurveySent === "YES" ? false : true;
                }
                else if (columnId === "totalDevicesQuoted") {
                    columnValue = quote.totalDevicesQuoted || 0;
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "countriesRequested") {
                    columnValue = quote.countriesRequested || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "salesPersonEmail") {
                    columnValue = quote.salesPersonEmail || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "currencyCode") {
                    columnValue = quote.currencyCode || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "quoteValidDate") {
                    columnValue = getDateWithSpecificFormat(quote.quoteValidDate) || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "quotationSubmissionDate") {
                    if (quote.status === "CREATED") {
                        isNotEditableQuote = false;
                    }
                    columnValue = quote.quotationSubmissionDate || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "acceptanceRejectionDate") {
                    if (quote.status === "ACCEPTED" || quote.status === "LOST") {
                        columnValue = getDateWithSpecificFormat(quote.quoteAcceptRejectDate) || "";
                        columnValueData = { ...column.data };
                        columnValueData.defaultValue = columnValue;
                    } else {
                        columnDataType = "string";
                        columnValue = "";
                    }
                }
                else if (columnId === "winningDeliveryPartner") {
                    columnValue = quote.status === "ACCEPTED" ? (quote.winningDeliveryPartner && quote.winningDeliveryPartner.length ? quote.winningDeliveryPartner.filter(option => option).join(",") : "") : "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "ctResponsible") {
                    columnValue = quote.ctResponsible || ""
                    columnValueData = { ...column.data, options: [] };
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "revitalizeCountries") {
                    if (quote.quoteType === "DRS_REVITALIZE") {
                        columnValue = quote.revitalizeCountries
                    }
                    else {
                        columnValue = "";
                    }
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    if (quote.quoteType === 'DRS') {
                        isDisabled = true
                    }
                }
                else if (columnId === "numberOfRevitalizeAssets") {
                    columnValue = quote.numberOfRevitalizeAssets || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    if (quote.quoteType === 'DRS') {
                        isDisabled = true
                    }
                }
            }

            if (columnDataType === "select") {
                let dropDownOptions = [];
                clickHandler = (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                if (columnId === "requestType") {
                    columnValue = quote.requestType || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [
                        { id: "", label: "Select" },
                        ...requestTypeOptions.map(option => ({ id: option, label: option }))
                    ];
                } else if (columnId === "leadOrigin") {
                    columnValue = quote.leadOrigin || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [
                        { id: "", label: "Select" },
                        ...leadOriginOptions.map(option => ({ id: option, label: option }))
                    ];
                } else if (columnId === "leadSource") {
                    columnValue = quote.leadSource || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [
                        { id: "", label: "Select" },
                        ...leadSourceOptions.map(option => ({ id: option, label: option }))
                    ];
                } else if (columnId === "requestorType") {
                    columnValue = quote.requestorType || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [];
                    if (config.data[0].hasOwnProperty("dropdownOptions") && config.data[0].dropdownOptions.hasOwnProperty(columnId)) {
                        dropDownOptions = config.data[0].dropdownOptions[columnId];
                        columnValueData.options = dropDownOptions;
                    }
                } else if (columnId === "npsSurveySent") {
                    columnValue = quote.npsSurveySent || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [];
                    if (config.data[0].hasOwnProperty("dropdownOptions") && config.data[0].dropdownOptions.hasOwnProperty(columnId)) {
                        dropDownOptions = config.data[0].dropdownOptions[columnId];
                        columnValueData.options = dropDownOptions;
                    }
                } else if (columnId === "status") {
                    columnValue = getStatusDescriptionFromStatusValue(quote.status) || "";
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [{ id: quote.status, label: columnValue }];

                    if (quote.status == "CREATED") {
                        columnValueData.options = [...columnValueData.options, ...createdStatusOptions];
                    } else if (quote.status == "PARTIALLY_CREATED") {
                        columnValueData.options = [...columnValueData.options, ...partiallyCreatedStatusOptions];
                    } else if (quote.status === "POSTPONED_TO_NEXT_QUARTER") {
                        if (quote.vpartialPriceProvided === true) {
                            columnValueData.options = [
                                ...columnValueData.options,
                                { id: "PARTIALLY_CREATED", label: "Partially Created" },
                                ...postponedToNextQuarterStatusOptions];
                        } else {
                            columnValueData.options = [
                                ...columnValueData.options,
                                { id: "CREATED", label: "Created" },
                                ...postponedToNextQuarterStatusOptions
                            ];
                        }
                    }
                    else if (quote.status === "VENDOR_PRICES_PROVIDED") {
                        columnValueData.options = [...columnValueData.options];
                    }
                    else if (quote.status === "VENDOR_PRICES_PENDING") {
                        columnValueData.options = [...columnValueData.options, ...vendorPricesPendingStatusOptions];
                    }
                    else if (quote.status === "ON_HOLD") {
                        if (quote.quoteCreationDate !== "") {
                            columnValueData.options = [...columnValueData.options, ...onHoldStatusCreationOptions];
                        }
                        else {
                            columnValueData.options = [...columnValueData.options, ...onHoldStatusOptions];
                        }
                    }

                    const originalQuote = quoteListCopy.find(orgQuote => orgQuote.quoteId === quote.quoteId) || {};
                    if (originalQuote.status === quote.status && QUOTE_EDIT_DISABLED.includes(quote.status)) {
                        isDisabled = true;
                    }
                }
                else if (columnId === 'leadCountry') {
                    columnValue = quote.leadCountry || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    const leadCountryOptions = [];
                    const listOfCountries = quote.countriesRequested ? [...new Set(quote.countriesRequested.split(','))] : [];
                    listOfCountries.map(country => {
                        if (getAllEnabledCountries().includes(country) && country.length >= 2) {
                            leadCountryOptions.push({ id: country, label: country })
                        }
                    });
                    columnValueData.options = leadCountryOptions;
                }
                else if (columnId === "revitalizeHPPrices") {
                    columnValue = getStatusDescriptionFromStatusValue(quote.hpFileUploadStatus) || '';
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    isDisabled = true;
                    if (quote.hpFileUploadStatus === 'PENDING') {
                        isDisabled = false;
                        columnValueData.options = [{ id: quote.hpFileUploadStatus, label: columnValue }, ...revitalizeHPPricesPendingOptions]
                    } else if (quote.hpFileUploadStatus === 'REQUESTED') {
                        columnValueData.options = [{ id: quote.hpFileUploadStatus, label: columnValue }]
                        isDisabled = false;
                        columnValueData.options = [{ id: "REQUESTED", label: "Requested" }]
                    } else if (quote.hpFileUploadStatus === 'PROVIDED') {
                        columnValueData.options = [{ id: "PROVIDED", label: "Provided" }]
                    }
                    if (quote.quoteType === 'DRS') {
                        isDisabled = true
                    }
                }
            }

            row.push({
                [columnId]: {
                    id: columnId,
                    columnId: columnId,
                    type: isNotEditableQuote ? "string" : columnDataType,
                    value: isNotEditableQuote ? columnValue : columnValueData,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    showInMobileViewAs: column.showInMobileViewAs,
                    highlightColumn: highlightColumn,
                    disabled: isDisabled,
                    clickHandler: clickHandler
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];

    return result;
}